import { Button, Stack } from '@mui/material';
import { useNavigate } from "react-router-dom";

const NewSimulationButton = () => {
    const navigate = useNavigate();
   
    return (
        <Stack direction='row' sx={{ justifyContent: 'center', alignContent: 'center', mt: 3 }}>
            <Button color="primary" variant="contained" onClick={() => navigate('/inputs/empty')}>
                Try a different date to empty your slurry
            </Button>
        </Stack>
    )
  };
  
  export default NewSimulationButton;